export type FleetSwapTranslations = {
  title: string;
  stepChooseCar: string;
  stepReview: string;
  stepDone: string;
  carLeavingSchedule: string;
  replacementCar: string;
  licensePlatePlaceholder: string;
  invalidLicensePlate: string;
  searchHint: string;
  noOtherCars: string;
  noMatchingCars: string;
  available: string;
  onSchedule: (scheduleName: string) => string;
  selected: (plate: string) => string;
  selectCarToContinue: string;
  cancel: string;
  continue: string;
  back: string;
  confirmSwap: string;
  addCarAndSwap: string;
  close: string;
  notInFleet: (plate: string) => string;
  lookUpHint: string;
  lookUpCar: string;
  foundInRegistry: string;
  addedOnConfirm: (plate: string) => string;
  cannotBeAdded: (plate: string) => string;
  ownedByOtherCustomer: (plate: string) => string;
  alreadyOnSchedule: (plate: string) => string;
  removed: string;
  added: string;
  whatHappens: string;
  outgoingLeaves: (plate: string, scheduleName: string) => string;
  addedToFleet: (plate: string) => string;
  incomingJoins: (plate: string, scheduleName: string) => string;
  nowOnSchedule: (plate: string, scheduleName: string) => string;
  noLongerOnSchedule: (plate: string) => string;
  canceledBookings: (count: number, plate: string) => string;
};

export const defaultFleetSwapTranslations: FleetSwapTranslations = {
  title: 'Swap car on schedule',
  stepChooseCar: 'Choose car',
  stepReview: 'Review',
  stepDone: 'Done',
  carLeavingSchedule: 'Car leaving the schedule',
  replacementCar: 'Replacement car',
  licensePlatePlaceholder: 'Search for reg. number',
  invalidLicensePlate: 'Invalid license plate number',
  searchHint: 'Cars in the fleet appear as you type. Enter a full license plate to look up a car that is not in it.',
  noOtherCars: 'No other cars can take over this schedule.',
  noMatchingCars: 'No cars in the fleet match your search.',
  available: 'Available',
  onSchedule: (scheduleName) => `On ${scheduleName}`,
  selected: (plate) => `${plate} selected`,
  selectCarToContinue: 'Select a car to continue',
  cancel: 'Cancel',
  continue: 'Continue',
  back: 'Back',
  confirmSwap: 'Confirm swap',
  addCarAndSwap: 'Attach car and swap',
  close: 'Close',
  notInFleet: (plate) => `${plate} is not in the fleet`,
  lookUpHint: 'Look it up in the vehicle registry to attach it.',
  lookUpCar: 'Look up car',
  foundInRegistry: 'Found in registry',
  addedOnConfirm: (plate) => `${plate} is attached when you confirm the swap.`,
  cannotBeAdded: (plate) => `${plate} cannot take over this schedule`,
  ownedByOtherCustomer: (plate) => `${plate} is registered to another customer.`,
  alreadyOnSchedule: (plate) => `${plate} is already on a fleet schedule.`,
  removed: 'Removed',
  added: 'Added',
  whatHappens: 'What happens when you confirm',
  outgoingLeaves: (plate, scheduleName) =>
    `${plate} leaves "${scheduleName}", and its upcoming bookings on this schedule are canceled. It stays in the fleet.`,
  addedToFleet: (plate) => `${plate} is attached to the fleet.`,
  incomingJoins: (plate, scheduleName) =>
    `${plate} joins "${scheduleName}" and is picked up by the next scheduled service.`,
  nowOnSchedule: (plate, scheduleName) => `${plate} is now on "${scheduleName}"`,
  noLongerOnSchedule: (plate) => `${plate} is no longer on the schedule and stays in the fleet.`,
  canceledBookings: (count, plate) =>
    count === 1
      ? `1 upcoming booking for ${plate} was canceled.`
      : `${count} upcoming bookings for ${plate} were canceled.`
};
